<template>
  <div>
    <div class="detail-container">
      <div class="detail-item">
        <div class="detail-item-con">
          <!--姓名-->
          <div>{{ $t('collectionCenter.compellation') }}</div>
          <div style="font-weight: bold">{{ detailData.realName }}</div>
        </div>
        <div style="flex: 1;padding: 10px">
          <div>CPF</div>
          <div style="font-weight: bold">{{ detailData.cpf }}</div>
        </div>
      </div>
      <div class="detail-item">
        <div class="detail-item-con">
          <!--账号状态-->
          <div>{{ $t('collectionCenter.codeStatus') }}</div>
          <div style="font-weight: bold">
            <div
              :style="{
                color: detailData.status === 1 ? '#0aa653'
                  : detailData.status === 2 ? '#dc2626'
                    : detailData.status === 3 ? '#909399' : '#d97706'
              }"
            >
              <div v-if="detailData.status === 1">{{ $t('userManage.effective') }}</div><!--有效-->
              <div v-if="detailData.status === 2">{{ $t('userManage.expired') }}</div><!--已到期-->
              <div v-if="detailData.status === 3">{{ $t('collectionCenter.Disabled') }}</div><!--已停用-->
              <div v-if="detailData.status === 4">{{ $t('userManage.expiringSoon') }}</div><!--即将到期-->
            </div>
          </div>
        </div>
        <div style="flex: 1;padding: 10px">
          <!--登录账号-->
          <div>{{ $t('userManage.LoginAccount') }}</div>
          <div style="font-weight: bold">{{ detailData.username }}</div>
        </div>
      </div>
      <div class="detail-item">
        <div class="detail-item-con">
          <!--所属转运中心-->
          <div>{{ $t('collectionCenter.owningTransitCenter1') }}</div>
          <div style="font-weight: bold">{{ detailData.siteName }}</div>
        </div>
        <div style="flex: 1;padding: 10px">
          <!--岗位-->
          <div>{{ $t('home.position') }}</div>
          <div style="font-weight: bold">{{ detailData.positionName }}</div>
        </div>
      </div>
      <div class="detail-item">
        <div class="detail-item-con">
          <!--生效时间-->
          <div>{{ $t('customerManagements.genterTiem') }}</div>
          <div style="font-weight: bold">{{ detailData.validFrom }}</div>
        </div>
        <div style="flex: 1;padding: 10px">
          <!--失效时间-->
          <div>{{ $t('seller.expirationTime') }}</div>
          <div style="font-weight: bold">{{ detailData.expireAt }}</div>
        </div>
      </div>
      <div style="display: flex">
        <div class="detail-item-con">
          <!--创建人-->
          <div>{{ $t('GlobalSetObj.CreatePeople') }}</div>
          <div style="font-weight: bold">{{ detailData.createUserName }}</div>
        </div>
        <div style="flex: 1;padding: 10px">
          <!--创建时间-->
          <div>{{ $t('GlobalSetObj.CreationTime') }}</div>
          <div style="font-weight: bold">{{ detailData.createTime }}</div>
        </div>
      </div>
    </div>
    <div style="padding-top: 10px">
      <!--账号操作记录-->
      <div style="font-weight: bold;margin-bottom: 10px;">{{ $t('userManage.AccountOperationRecord') }}</div>
      <div style="max-height: 200px;overflow-y: auto">
        <div v-for="(item, index) in tableData" :key="index" style="border-bottom: 1px solid #ddd;padding: 10px 0;display:flex;">
          <div style="margin-right: 20px;">{{ item.operationTime }}</div>
          <div>{{ item.description }}</div>
        </div>
      </div>
      <div class="page-size">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          small
          style="margin: 10px 0"
          @current-change="currentChange"
          @size-change="sizeChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getFreelancerDetailApi, getFreelancerLogPageApi } from '@/api/user';

export default {
  name: 'ViewDetail',
  props: {
    accountDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      detailData: null,
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          accountId: null
        }
      },
      total: 0,
      tableData: []
    };
  },
  created() {
    this.getDetailData();
    this.getLogList();
  },
  methods: {
    // 查询详情
    getDetailData() {
      getFreelancerDetailApi(this.accountDetail.id).then(res => {
        if (res.code === 200) {
          this.detailData = res.data;
        }
      });
    },
    // 操作记录
    getLogList() {
      this.queryForm.params.accountId = this.accountDetail.id;
      getFreelancerLogPageApi(this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 翻页
    currentChange(val) {
      this.queryForm.pageNumber = val;
      this.getLogList();
    },
    // 每页显示数量
    sizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getLogList();
    }
  }
};
</script>
<style lang="scss" scoped>
.detail-container {
  border: 1px solid #ddd;
  border-radius: 10px;
}
.detail-item {
  display: flex;
  border-bottom: 1px solid #ddd;
}
.detail-item-con {
  flex: 1;
  border-right: 1px solid #ddd;
  padding: 10px;
}
::v-deep .page-size .el-input__inner {
  height: 22px !important;
  line-height: 22px !important;
}
::v-deep .page-size button {
  height: 22px !important;
}
::v-deep .page-size .number {
  height: 22px !important;
  line-height: 22px !important;
}
</style>
